import { load } from './load';

export default load({
  "нь": "ń",
  "ль": "ĺ",
  "зь": "ź",
  "сь": "ś",
  "чь": "ć",
  "ть": "t́",
  "дь": "d́",
  "рь": "ŕ",
  "ӑ": "å",
  "б": "b",
  "в": "v",
  "ў": "v",
  "г": "g",
  "ґ": "g",
  "д": "d",
  "дж": "dž",
  "ђ": "dž",
  "е": "e",
  "є": "ě",
  "ѣ": "ě",
  "ё": "e",
  "ж": "ž",
  "з": "z",
  "и": "i",
  "ј": "j",
  "ї": "ji",
  "й": "j",
  "к": "k",
  "л": "l",
  "љ": "lj",
  "м": "m",
  "н": "n",
  "њ": "nj",
  "о": "o",
  "п": "p",
  "р": "r",
  "с": "s",
  "т": "t",
  "у": "u",
  "ф": "f",
  "х": "h",
  "ц": "c",
  "ч": "č",
  "ћ": "ć",
  "ш": "š",
  "щ": "šč",
  "ъ": "ȯ",
  "ы": "y",
  "ю": "ju",
  "я": "ja",
  "ѫ": "ų",
  "ѧ": "ę",
  "ѥ": "je",
  "ꙑ": "y",
  "ӗ": "ė"
});
